import type { ServiceLevelStatus as BaseServiceLevelStatus } from '@forest/paywall-core'
import { isHTTPError } from 'ky'
import { api } from '~/services/api'

export type ServiceLevelStatus = BaseServiceLevelStatus & {
  is_premium: boolean
}

export function getServiceLevelStatus(userId: number) {
  return api.service
    .get(`user/users/${userId}/service-levels/status`)
    .json<ServiceLevelStatus>()
}

export function getLatestSubscriptionLog(userId: number) {
  return api.service
    .get(`user/users/${userId}/subscription-logs/latest`)
    .json<{
      subscription_log: { expires_at: string }
    }>()
    .then(({ subscription_log }) => subscription_log)
    .catch((err) => {
      if (isHTTPError(err) && err.response.status === 404) {
        return null
      }
      throw err
    })
}
